import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';

export class AssignBrandToProviderUseCase {
  constructor (private serviceProviderRepository: ServiceProviderRepository) {}

  async execute (providerId: number, brandId: number): Promise<void> {
    return await this.serviceProviderRepository.assignBrand(providerId, brandId);
  }
}
